import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, allow }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const navState = useMemo(() => ({ from: loc }), [loc]);
  if (loading || user === null)
    return (
      <div className="h-screen flex items-center justify-center text-sm text-slate-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" state={navState} replace />;
  // Pending (non-vendor) parties: send to root so RootRedirect renders the
  // friendly PendingApprovalScreen instead of looping on missing role.
  if (user._pending && !(user.kind === "vendor" || user.role === "vendor")) {
    if (loc.pathname !== "/") return <Navigate to="/" replace />;
    return children;
  }
  if (allow && !allow.includes(user.role))
    return <Navigate to={user.role === "client" ? "/client" : "/"} replace />;
  return children;
}
